import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTableR";
import axios from "axios";
import { RegistroAseoUrbano } from "./modalAseoUrbano";
import { Toasts } from "../../toasts";
//UI
import { SearchInput } from "../../../ui/inputs/Input";

const headCells = [
  {
    id: "",
    label: "CODIGO",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "CEDULA/RIF",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "NOMBRE ARRENDATARIO",
    width: "220px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "RENTA",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "OPCIONES",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];
function TablaAseoUrbano(props) {
  /* variables de estado */
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const permiso = JSON.parse(localStorage.getItem("accrenta"));
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const [inmobiliaria, setInmobiliaria] = useState();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [rentas, setRentas] = useState();
  const [inmueble, setInmueble] = useState();
  const [comercio, setComercio] = useState();
  const [clasificador, setClasificador] = useState();
  const [actividad] = useState();
  const [declaWeb, setDeclaWeb] = useState(false);
  const [periodoR, setPeriodoR] = useState(1);
  const [periodoPagoR, setPeriodoPagoR] = useState();
  const [confiRenta, setConfigRenta] = useState();
  const [valorPorce, setValorPorce] = useState(0.0);
  const [valorUT, setValorUT] = useState();
  const [credito, setCredito] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [factorCambio, setFactorCambio] = useState(0);

  let periodo;
  let periodopago;

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const handleSearch2 = (e) => {
    let target = e.target;

    if ((target.name = "Search")) {
      target.value = target.value.toUpperCase();

      setFilterFn({
        fn: (items) => {
          if (target.value === "") {
            return items;
          } else {
            return items.filter((x) => {
              if (
                x.idrentas.toLowerCase().includes(target.value.toLowerCase()) ||
                x.cedrif.includes(target.value) ||
                x.nombrearrendatario
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
              ) {
                return x;
              }
            });
          }
        },
      });
    }
  };
  const cerrarModalActualizar = () => {
    setMostrar5(false);
    blanquearCampos();
    setDeuda();
    setHistorico();
  };

  const seleccionarFactorCambio = () => {
    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setFactorCambio(response.data.valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const consultarValor = (ope, id, per) => (event) => {
    event.preventDefault();
    if (per.toString() === "1") {
      if (ope === 1) {
        setMostrar5(true);
        setOperacion(1);
        setInmueble();
      } else if (ope === 4) {
        seleccionarRegistro(id);
        setOperacion(4);
      } else if (ope === 2) {
        setOperacion(2);
        seleccionarRegistro(id);
      } else if (ope === 3) {
        setOperacion(3);
        seleccionarRegistro(id);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          ope === 1
            ? "No posee permiso para Registrar"
            : ope === 2
            ? "No posee permiso para Editar"
            : ope === 3
            ? "No posee permiso para Eliminar"
            : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  const blanquearCampos = () => {
    setActivate(false);
    setOperacion(0);
    setInmobiliaria();
    setDeuda();
    setHistorico();
  };

  const seleccionarRegistro = (idrentas) => {
    let campos = "*";
    let nomtab = "rentasinmobiliarias";
    let nomid = "idrentas";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idrentas}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idrentas > 0) {
            setInmobiliaria(response.data);
            if (response.data.tipotabla === 0) {
              seleccionarRegistroInmueble(response.data);
              blanquearCampos;
            } else if (response.data.tipotabla === 1) {
              seleccionarRegistroComercio(response.data);
              blanquearCampos;
            } else {
              SelectDeudaC(response.data);
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistroClasificador = () => {
    let campos = "*";
    let nomtab = "claseaseo";
    let condi = "actualizada = true AND tipo = 0";
    let orden = "idclaseaseo";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setClasificador(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarRegistroTP = () => {
    let campos = "*";
    let nomtab = "tiporentas";
    let condi = "codigoimpuesto=3";
    let orden = "idtiporentas";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRentas(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarRegistroComercio = (data) => {
    let campos = "*";
    let nomtab = "comercio";
    let nomid = "idcomercio";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcomercio > 0) {
            setComercio(response.data);
            setInmueble();
            SelectDeudaC(data);
            setCredito(response.data.credito);
          } else {
            SelectDeudaC(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistroInmueble = (data) => {
    let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idinmueble > 0) {
            setInmueble(response.data);
            SelectDeudaC(data);
            setCredito(response.data.credito);
          } else {
            SelectDeudaC(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarConfigRentas = () => {
    let campos = "*";
    let nomtab = "configrentas";
    let orden = "1";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setConfigRenta(response.data[0]);
          setDeclaWeb(response.data[0].declaracionweb);
          switch (parseInt(response.data[0].periodopago)) {
            case 1:
              periodo = 12;
              periodopago = 1;
              setPeriodoR(periodo);
              setPeriodoPagoR(periodopago);
              break;
            case 2:
              periodo = 4;
              periodopago = 3;
              setPeriodoR(periodo);
              setPeriodoPagoR(periodopago);
              break;
            case 3:
              periodo = 1;
              periodopago = 1;
              setPeriodoR(periodo);
              setPeriodoPagoR(periodopago);
              break;
          }
          if (response.data.valorporcentual == 1) {
            setValorPorce(100.0);
          } else {
            setValorPorce(1000.0);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarValorPetro = () => {
    let endpoint = op.conexion + "/api/efiscal/valorpetro";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValorUT(response.data.valor);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistros = () => {
    let nomtab = "rentasinmobiliarias";
    let nomid = "idtiporenta";
    let nomtab2 = "tiporentas";
    let nomid2 = "idtiporentas";
    let condi = "codigoimpuesto=3";
    let endpoint =
      op.conexion +
      `/api/aseo/aseo?nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}&condi=${condi} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const SelectDeudaC = (data) => {
    let tabla = "aseo";
    let endpoint = "";
    /* if (espiritu === 0) {
      endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${data.idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    } else {
      endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${data.idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    } */
   endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${data.idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu * factorCambio,
                intereses: response.data[i].intmoradeu * factorCambio,
                multa: response.data[i].multa * factorCambio,
                recargo: response.data[i].recargodeu * factorCambio,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
          setMostrar5(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarRegistroClasificador();
    seleccionarRegistroTP();
    seleccionarConfigRentas();
    seleccionarValorPetro();
    seleccionarFactorCambio();
  }, []);

  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 rounded d-flex flex-column justify-content-center">
      <header className="col-12 m-0 p-2 d-flex align-items-center justify-content-between azulGradiant rounded-top text-light">
      <h3 className="fw-bold m-0">Gestion de Contribuyentes Aseo Urbano</h3>
      <button  onClick={cerrar} className="btn btn-sm bg-light">
        <i className="fa fa-times" />
        </button>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <SearchInput
            placeholder="Buscar"
            onChange={handleSearch2}
            name="Search"
          />
        </div>
        <div className="col-auto m-0 p-0">
          <button
            onClick={consultarValor(1, "", permiso.toString().substring(1, 2))}
            className={
              permiso.toString().substring(1, 2) === "1"
                ? "btn btn-sm btn-primary rounded-pill"
                : "btn btn-sm btn-secondary rounded-pill"
            }
          >
            <i className="fas fa-plus"></i>{" "}
          </button>
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idrentas} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10px",
                    }}
                  >
                    {item.idrentas}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "80px",
                    }}
                  >
                    {item.cedrif}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "left",
                      width: "250px",
                    }}
                  >
                    {item.nombrearrendatario}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "300px",
                    }}
                  >
                    {item.descripcion}
                  </td>

                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "180px",
                    }}
                  >
                    <button
                      onClick={consultarValor(
                        4,
                        item.idrentas,
                        permiso.toString().substring(0, 1)
                      )}
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarValor(
                        2,
                        item.idrentas,
                        permiso.toString().substring(2, 3)
                      )}
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarValor(
                        3,
                        item.idrentas,
                        permiso.toString().substring(3, 4)
                      )}
                      className={
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <RegistroAseoUrbano
        factorCambio={factorCambio}
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        inmobiliaria={inmobiliaria}
        rentas={rentas}
        operacion={operacion}
        onHideRenderizar={seleccionarRegistros}
        onHideRenderizar2={SelectDeudaC}
        clasificador={clasificador}
        inmueble={inmueble}
        comercio={comercio}
        actividad={actividad}
        confiRenta={confiRenta}
        periodoPagoR={periodoPagoR}
        periodoR={periodoR}
        valorUT={valorUT}
        valorPorce={valorPorce}
        declaWeb={declaWeb}
        deuda={deuda}
        historico={historico}
        credito={credito}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}
export default TablaAseoUrbano;
